<template lang="pug">
.speaker-list-item
  router-link(:to="{ name: 'speaker', params: { id: speaker.id } }")
    cl-img(
      v-if="speaker._embedded.profile_image"
      :cl-id="speaker._embedded.profile_image.cl_id"
      :transform="{ width: 300, height: 300, crop: 'thumb' }"
    )
    .placeholder-image(v-else)
    .speaker-name {{ speaker.full_name }}
    .speaker-episodes.is-size-7.has-text-grey-light {{ speaker.episode_count }} {{ sermonLabel }}
</template>

<script>
export default {
  name: 'speaker-list-item',
  computed: {
    sermonLabel() {
      return this.value.episode_count === 1 ? 'sermon' : 'sermons';
    },
    speaker() {
      return this.value;
    },
  },
  props: {
    value: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
</script>

<style lang="scss">
.speaker-list-item {
  text-align: center;
  margin: 0.35rem 0;
  a {
    color: $black-bis;
    &:hover {
      img {
        transform: translate3d(0,-4px,0);
        box-shadow: 0 3px 30px rgba(0,0,0,0.15);
      }
    }
  }
  img, .placeholder-image {
    margin: 0 auto;
    width: 150px;
    height: 150px;
    border-radius: 300px;
    background-color: $grey-light;
    transform: translate3d(0,0,0);
    transition: transform 0.35s ease-in-out, box-shadow 0.35s ease-in-out;
  }
  .speaker-name {
    font-family: $heading-font;
    font-weight: 500;
    font-size: 1.1rem;
    margin: 0.5rem 0 0.35rem 0;
  }
  .speaker-episodes {
    font-color: $grey-light;
  }
}
</style>
